import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateFilters } from "store/filters/operations";
import { selectFilters } from "store/filters/selectors";
import { CustomDatePicker } from "reusableComponents";
import "react-datepicker/dist/react-datepicker.css"; // Import the stylesheet

import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

const FromDateFilterBtn = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation("global");
  const filters = useSelector(selectFilters);
  const datePickerRef = useRef(null);

  const handleFromDateChange = (date) => {
    // Update the From date in the filters
    dispatch(updateFilters({ from: date }));

    // Update To date if it's less than the new From date
    if (filters.to && date > filters.to) {
      dispatch(updateFilters({ to: null })); // Optionally reset To date
    }
  };

  return (
    <div ref={datePickerRef} className={styles.datePickerWrapper}>
      <CustomDatePicker
        selectedDate={filters.from}
        onDateChange={handleFromDateChange}
        className={styles.customDatePickerInput}
      />
    </div>
  );
};

export default FromDateFilterBtn;
